import { render } from "./HR_Deduction_Dialog.vue?vue&type=template&id=016f1662&scoped=true&ts=true"
import script from "./HR_Deduction_Dialog.vue?vue&type=script&lang=ts"
export * from "./HR_Deduction_Dialog.vue?vue&type=script&lang=ts"

import "./HR_Deduction_Dialog.vue?vue&type=style&index=0&id=016f1662&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-016f1662"]])

export default __exports__